import {
  Entity,
  type EntityFields,
  type EntityRecord,
  Fields,
} from '@burnsred/entity';

class MockSystemRefEntity extends Entity {
  static fields: EntityFields<MockSystemRefEntityFields> = {
    uuid: new Fields.IdField(),
    name: new Fields.CharField({ blank: true, local: true }),
    slug: new Fields.CharField({ blank: true, local: true }),
  };
}

export type MockSystemRefEntityFields = {
  uuid: string;
  name: string;
  slug: string;
};

export type MockSystemRefEntityRecord = EntityRecord<MockSystemRefEntityFields>;

export default MockSystemRefEntity;
